import React from "react";
import * as Icons from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { STEPS } from "@/data/mock";

const FLOW = ["Diagnose", "Prioritize", "Plan", "Practice", "Analyze", "Adapt"];

export const HowItWorks = () => (
  <section id="how" className="bg-background py-24 md:py-32 scroll-mt-16" data-testid="how-it-works-section">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto mb-6">
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold mb-4">How it works</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
          A system that runs your preparation loop.
        </h2>
      </Reveal>

      <Reveal className="flex flex-wrap items-center justify-center gap-2 mb-16">
        {FLOW.map((f, i) => (
          <React.Fragment key={f}>
            <span className="text-sm font-medium text-muted-foreground">{f}</span>
            {i < FLOW.length - 1 && <Icons.ArrowRight className="h-3.5 w-3.5 text-primary/50" />}
          </React.Fragment>
        ))}
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {STEPS.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Sparkles;
          return (
            <Reveal key={s.n} delay={i * 0.07}>
              <div className="group relative h-full rounded-2xl border border-border bg-card p-7 overflow-hidden hover:border-primary/40 transition-colors">
                <div className="absolute -top-4 -right-2 font-display text-7xl font-bold text-primary/5 group-hover:text-primary/10 transition-colors select-none">
                  {s.n}
                </div>
                <div className="relative">
                  <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-amber-400/20 to-red-600/20 flex items-center justify-center mb-5">
                    <Icon className="h-5.5 w-5.5 text-primary" />
                  </div>
                  <p className="text-xs font-semibold text-primary mb-1">{s.n}</p>
                  <h3 className="font-display text-lg font-bold tracking-wide mb-2">{s.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">{s.body}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
